exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".non-gfm-markdown-block[data-v-32c56741] p:last-of-type{margin-bottom:0}.non-gfm-markdown-block[data-v-32c56741] code{word-break:break-all}.non-gfm-markdown-block[data-v-32c56741] pre{white-space:pre-wrap}", ""]);

